import Badge from "@/components/core/badge";
import {
	Blanket,
	BlanketImage,
	BlanketInfo,
} from "@/components/core/blanket.tsx";
import {
	IconCancel,
	IconCircleDot,
	IconDatabaseExclamation,
	IconGavel,
	IconProgress,
} from "@tabler/icons-react";
import { Link } from "@tanstack/react-router";

export const ProfileCaseList = () => {
	const hasData = true;
	const ongoing = true;

	return (
		<div className="flex flex-col w-full mt-6">
			{hasData ? (
				<div className="flex flex-col w-full pl-3">
					<div className="flex flex-col w-full pl-6 gap-6 border-l border-border/50">
						<div className="relative flex flex-col w-full gap-2">
							<div className="absolute right-full -top-1 mr-2 inline-flex w-[32px] h-[32px] rounded-full justify-center items-center bg-background text-primary-600">
								<IconCircleDot size={18} stroke={2} />
							</div>
							<div className="flex flex-row items-center w-full gap-2">
								<Link
									to="/"
									className="text-base font-semibold text-blue-600 hover:text-blue-500 truncate"
								>
									Case No. 1
								</Link>
								<Badge className="uppercase" size="xs" color="green-light">
									Ongoing - Trial Proper
								</Badge>
							</div>
							<div className="flex flex-col w-full rounded-md p-4 border border-border/50">
								<div className="inline-flex flex-col w-auto">
									<span className="text-base font-bold text-foreground-dark">
										Case Title
									</span>
									<span className="text-base text-foreground">
										Case filed January 1 1975
									</span>
									<span className="text-base text-foreground truncate">
										Some case exerpt goes here, please add more
									</span>
								</div>
							</div>
						</div>

						<div className="relative flex flex-col w-full gap-2">
							<div className="absolute right-full -top-1 mr-2 inline-flex w-[32px] h-[32px] rounded-full justify-center items-center bg-background text-primary-600">
								<IconCircleDot size={18} stroke={2} />
							</div>
							<div className="flex flex-row items-center w-full gap-2">
								<Link
									to="/"
									className="text-base font-semibold text-blue-600 hover:text-blue-500 truncate"
								>
									Case No. 2
								</Link>
								<Badge className="uppercase" size="xs" color="green-light">
									Ongoing Post Judgment
								</Badge>
							</div>
							<div className="flex flex-col w-full rounded-md p-4 border border-border/50">
								<div className="inline-flex flex-col w-auto">
									<span className="text-base font-bold text-foreground-dark">
										Case Title
									</span>
									<span className="text-base text-foreground">
										Case filed January 1 1975
									</span>
									<span className="text-base text-foreground truncate">
										Some case exerpt goes here, please add more
									</span>
								</div>
							</div>
						</div>

						<div className="relative flex flex-col w-full gap-2">
							<div className="absolute right-full -top-1 mr-2 inline-flex w-[32px] h-[32px] rounded-full justify-center items-center bg-background text-primary-600">
								<IconCircleDot size={18} stroke={2} />
							</div>
							<div className="flex flex-row items-center w-full gap-2">
								<Link
									to="/"
									className="text-base font-semibold text-blue-600 hover:text-blue-500 truncate"
								>
									Case No. 3
								</Link>
								<Badge className="uppercase" size="xs" color="red-light">
									Case Closed
								</Badge>
							</div>
							<div className="flex flex-col w-full rounded-md p-4 border border-border/50">
								<div className="inline-flex flex-col w-auto">
									<span className="text-base font-bold text-foreground-dark">
										Case Title
									</span>
									<span className="text-base text-foreground">
										Case filed January 1 1975
									</span>
									<span className="text-base text-foreground truncate">
										Some case exerpt goes here, please add more
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<div className="flex flex-col w-full rounded-md border border-border/50">
					<Blanket width="sm">
						<BlanketImage
							icon={<IconDatabaseExclamation size={24} stroke={1.5} />}
						/>
						<BlanketInfo
							title="No Data"
							message="No available data for now. Please check back later or refresh the page."
						/>
					</Blanket>
				</div>
			)}
		</div>
	);
};
